export const getPrivacyOffers = (event, $locale) => {
    const customRulesKey = 'customRules'
        + $locale.localeName.substring(0, 1).toUpperCase()
        + $locale.localeName.substring(1, 2).toLowerCase();

    const personalTermsAgree = event.moduleAuth.rules && !event.client.settings?.disableDefaultRules && $locale.get('registration.organizerAgreement', {
        name: event.client.organizationName,
        inn: event.client.organizationInn,
    });

    const termsAgree = event.moduleAuth.rules && !event.client.settings?.disableDefaultRules && $locale.get('auth.login.agree', {
        userAgreementLink: 'https://comdi.com/legal/user-agreement.pdf',
        userPrivateAgreementLink: 'https://www.comdi.com/legal/private-agreement-event.pdf',
    });

    const customTermsAgree = event.moduleAuth[customRulesKey]
        || (event.client.settings && event.client.settings[customRulesKey])
        || null;

    const offers = {};
    if (personalTermsAgree) {
        offers['personalTermsAgree'] = personalTermsAgree;
    }
    if (termsAgree) {
        offers['termsAgree'] = termsAgree;
    }
    if (customTermsAgree) {
        offers['customTermsAgree'] = customTermsAgree;
    }

    return offers;
};
